import apiService from './api-service'

const promissoriesService = {}

/**
 * Cancel a promissory
 * @param  object body
 * @return promissory
 */
promissoriesService.cancel = function (id, body) {
  return apiService.post(`/promissory/${id}/cancel`, body).then(res => res.data)
}

/**
 * Edit a promissory
 * @param  object body
 * @return promissory
 */
promissoriesService.edit = function (id, body) {
  return apiService.post(`/promissory/${id}/edit`, body).then(res => res.data)
}

/**
 * Create an Attachment's promissory
 * @param  int attachmentId
 * @param  object body
 * @return attachment
 */
promissoriesService.post = function (attachmentId, body) {
  return apiService.post(`attachment/${attachmentId}/promissory`, body).then(res => res.data)
}

export default promissoriesService



// WEBPACK FOOTER //
// ./src/services/promissories.js